import { render, staticRenderFns } from "./AddFormLesiones.vue?vue&type=template&id=6c23ed5a"
import script from "./AddFormLesiones.vue?vue&type=script&lang=js"
export * from "./AddFormLesiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports